import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import PlayerFooterButton from "core/components/PlayerFooterButton";
import SkuflixShareIcon from "core/icons/skuflix/SkuflixShareIcon";
import ShareDialog from "core/components/ShareDialog";

/**
 * Кнопка «Поделиться» в панели эмбеда: открывает ShareDialog (ссылка,
 * embed-код, «Начать с», системное меню «Другие приложения») по макету
 * «ВидеоСпортс UI» (Figma, EmbedVideo, раздел «Поделиться»).
 */
function ShareButton({ contentId, shareText, shareUrl, getCurrentTime }) {
  const { t } = useTranslation("core");

  const [open, setOpen] = useState(false);

  const onOpen = (event) => {
    // Клик не должен всплыть до плеера и запустить видео
    event.stopPropagation();
    setOpen(true);
  };

  const onClose = () => setOpen(false);

  return (
    <>
      <PlayerFooterButton title={t("shareButton.title")} onClick={onOpen}>
        <SkuflixShareIcon />
      </PlayerFooterButton>

      <ShareDialog
        open={open}
        onClose={onClose}
        contentId={contentId}
        shareText={shareText}
        shareUrl={shareUrl}
        getCurrentTime={getCurrentTime}
      />
    </>
  );
}

ShareButton.propTypes = {
  contentId: PropTypes.string,
  shareDescription: PropTypes.string,
  shareText: PropTypes.string.isRequired,
  shareUrl: PropTypes.string.isRequired,
  shareImage: PropTypes.string,
  getCurrentTime: PropTypes.func,
};

export default ShareButton;
